<template>
  <div class="cq-heading">
    <h2 class="heading" :class="{'whitecolor': white, 'left': leftside, 'right':rightside}"> <slot/> </h2> 
  </div>
</template>

<script>
export default {
  props: {
    white: {
      default: false
    },
    leftside:{
      default: false
    },
    rightside:{
      default: false
    }
  }
}
</script>

<style>
  .cq-heading h2{
      font-size: 45px;
      font-family: 'Seravek-Light';
      color: var(--primary-color);
  }

  .whitecolor{
    font-size: 79px !important;
    color:#fff !important;
    font-family: 'Seravek-Light';
  }

  .left{
    font-size: 50px !important;
    text-align: left;
    margin-bottom: 0 !important;
  }

  .right{
    font-size: 50px !important;
    text-align: right;
    margin-bottom: 0 !important;
  }

@media only screen and (max-width: 992px){
  .cq-heading h2{
    font-size: 33px;
  }

  .whitecolor{
    font-size: 40px !important;
  }

  .left{
    font-size: 33px !important;
    padding: 0;
  }

  .right{
    font-size: 33px !important;
    padding: 0;
  }
}

</style>